import instance from '@apis/instance';
import { AppCustomResponse } from '@models/custom';

class AppCustomApi {
  static getAppCustom(): Promise<AppCustomResponse> {
    return instance.get('/app-custom');
  }
}

export default AppCustomApi;
